import { getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import {
  TENANT_BOOTSTRAP_ERROR_CODES,
  TenantBootstrapError,
} from "./bootstrapErrors";

const sanitizeAppNameFragment = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-:_]/g, "-");

export const buildTenantFirebaseAppName = (tenantSlug, projectId) =>
  `tenant:${sanitizeAppNameFragment(tenantSlug)}:${sanitizeAppNameFragment(
    projectId
  )}`;

export const createTenantFirebaseInitializer = () => {
  const tenantFirebaseByAppName = new Map();

  return {
    initializeTenantFirebase(firebaseConfig, tenantSlug) {
    const appName = buildTenantFirebaseAppName(
      tenantSlug,
      firebaseConfig.projectId
    );

    const cachedTenantFirebase = tenantFirebaseByAppName.get(appName);
    if (cachedTenantFirebase) {
      return cachedTenantFirebase;
    }

    try {
      const app =
        getApps().find((candidate) => candidate.name === appName) ||
        initializeApp(firebaseConfig, appName);

      const tenantFirebase = {
        app,
        db: getFirestore(app),
        auth: getAuth(app),
        storage: getStorage(app),
        appName,
      };
      tenantFirebaseByAppName.set(appName, tenantFirebase);

      return tenantFirebase;
    } catch (error) {
      throw new TenantBootstrapError(
        TENANT_BOOTSTRAP_ERROR_CODES.CUSTOMER_FIREBASE_INIT_FAILED,
        "Customer Firebase initialization failed.",
        { tenantSlug, projectId: firebaseConfig.projectId, cause: error }
      );
    }
  },
  };
};
